<template>
  <div class="form-registro">
    <main class="container registro p-5">
        <img class="mb-4 mx-auto d-block" src="@/assets/img/logo-vertical.png" alt="" width="250">
        <h1 class="titulo-r text-center">Ingrese su nueva <br>
            contraseña</h1>
        <p class="text-center texto-n">La contraseña debe contener mayúsculas <br> minúsculas (a-z, A-Z) números y caracteres <br> especiales (1*&%)</p>
        <form @submit.prevent="submit" class="d-flex justify-content-center p-2">
            <div class="col-sm-6">
                <label for="Contraseña" class="form-label">Nueva contraseña</label>
                <input type="password" class="form-control" ref="Contraseña" id="Contraseña" name="Contraseña" v-model="newPasswordForm.Clave" v-validate="'required|min:5|verify_password'"  >


                <label for="ConfirmaClave" class="form-label m-t">Repetir contraseña</label>
                <input type="password" class="form-control" id="ConfirmaClave" name="ConfirmaClave" v-model="ClaveR" v-validate="'required|confirmed:Contraseña'" data-vv-as="ConfirmarContraseña" >

                <div class="alert alert-danger" v-show="errors.any()">
                  <div v-if="errors.has('Contraseña')">
                    {{ errors.first('Contraseña')}}
                  </div>
                  <div v-if="errors.has('ConfirmaClave')">
                    {{ errors.first('ConfirmaClave') }}
                  </div>
                </div>
            
                  <button class="w-100 btn btn-lg btn btn-registro m-t" type="submit">Recuperar contraseña </button>
                </div> 
        </form>
    </main>
</div>    
</template>

<script>

import helpers from '@/services/helpers'
import auth from '@/services/auth'

import VeeValidate, { Validator } from "vee-validate";



export default {
  name: "NuevaContraseña",
  data() {
    return {
      newPasswordForm: {
        Correo: localStorage.getItem("mailRec"),
        Clave: "",
      },
      ClaveR: "",
      user: {
        password: "",
      },
      deshabilitado: true,
    };
  },

 

  mounted() {
    helpers.habilitarBoton(this);

    Validator.extend('verify_password', {
        getMessage: field => `La contraseña debe contener al menos: 1 letra mayúscula, 1 letra minúscula, 1 número y un carácter especial`,
        validate: value => {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(value);
        }
    });
  },
  
  methods: {
    async submit(e) {

       this.$validator.validateAll().then(valid => {
          if (valid) {
             let _this = this;
             if (auth.updatepassword(this)){
              //console.log("VERIFICACIÓN CORRECTA");
            }
            else{
              //console.log("ERROR AL VERIFICAR");
            }
            helpers.habilitarBoton(this, 4);

           }
        });

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/NuevaContraseña.vue